// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3jA0l","title":"AfterBackImages_title__9Vvgz","images":"AfterBackImages_images__1lS2Y"};